"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenAsset = exports.TokenType = void 0;
const utils_1 = require("../utils");
var TokenType;
(function (TokenType) {
    TokenType["Generic"] = "generic";
    TokenType["Gas"] = "gas";
    TokenType["ERC20"] = "erc20";
    TokenType["Wrapped"] = "wrapped";
    TokenType["JRC20"] = "jrc20";
    TokenType["JNT"] = "jnt";
})(TokenType || (exports.TokenType = TokenType = {}));
/**
 * Representation of an asset on a chain with its common values
 * such as an id, a name, a symbol and decimals.
 */
class TokenAsset {
    type = TokenType.Generic;
    assetId;
    name;
    symbol;
    decimals;
    constructor(assetId, name, symbol, decimals) {
        this.assetId = assetId;
        this.name = name;
        this.symbol = symbol;
        this.decimals = decimals;
    }
    /**
     * Get an AssetValue helper of this token set to a value.
     * @param value The value, or amount of this asset to set.
     * @returns A new AssetValue which can be used to display the provided value with the decimals of this token.
     */
    getAssetValue(value) {
        return new utils_1.AssetValue(value, this.decimals);
    }
}
exports.TokenAsset = TokenAsset;
